"use client";
import { jsx } from "react/jsx-runtime";
import "react";
import { useContainerBreakpoints } from "../../hooks/index.js";
import { ResponsiveContext } from "./hooks/useResponsive.js";
function ResponsiveWrapper({ children, breakpoints }) {
    const { containerRef, ...breakpointValues } = useContainerBreakpoints({
        breakpoints
    });
    return /*#__PURE__*/ jsx(ResponsiveContext.Provider, {
        value: breakpointValues,
        children: /*#__PURE__*/ jsx("div", {
            ref: containerRef,
            className: "@container",
            children: children
        })
    });
}
export { ResponsiveWrapper };
